var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDpdxUnits(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.064,
    height: 37.992,
    viewBox: "0 -1391 2931.6 2099",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dpdx_units_svg__a",
    d: "M130 622q-7 7-11 9t-16 3-43 3H27v46h249q39 0 55 1 88 0 140-13t96-55q57-53 57-127 0-68-51-117t-122-65q-22-5-123-6h-94V181q0-119 3-123 8-11 67-12h33V0h-11q-21 3-144 3Q47 3 38 0H27v46h33q42 1 51 3t19 12v561zm377-134q0 26-1 40t-6 36-17 33-33 23-53 15q-12 2-90 2h-21q-49 0-52-9-3-4-3-145V342h108q51 0 84 7t58 33q26 29 26 106z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dpdx_units_svg__b",
    d: "M137 305h-22l-37 15-15 39q0 35 34 62t121 27q73 0 118-32t60-76q5-14 5-31t1-115v-70q0-48 5-66t21-18q15 0 20 16t5 53v36h40v-39q-1-40-3-47-9-30-35-47T400-6t-47 18-24 42v4l-2-3q-2-3-5-6t-8-9-12-11-15-12-18-11-22-8-26-6-31-3q-60 0-108 31t-48 87q0 21 7 40t27 41 48 37 78 28 110 15h14v22q0 34-6 50-22 71-97 71-18 0-34-1t-25-4-8-3q22-15 22-44 0-25-16-39zm-11-199q0-31 24-55t59-25q38 0 67 23t39 60q2 7 3 66 0 58-1 58-8 0-21-1t-45-9-58-20-46-37-21-60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dpdx_units_svg__c",
    d: "M423 750q9 0 15-6t6-14q0-5-173-482T92-240q-7-10-17-10-7 0-13 5t-6 14q0 10 174 488t177 483q4 10 16 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dpdx_units_svg__d",
    d: "M41 46h14q39 0 47 14v62q0 17 1 39t0 42v66q0 35-1 59v23q-3 19-14 25t-45 9H25v23q0 23 2 23l10 1q10 1 28 2t37 2q17 1 36 2t29 3 11 1h3v-40q0-38 1-38t5 5 12 15 19 18 29 19 38 16q20 5 51 5 15 0 28-2t23-6 19-8 15-9 11-11 9-11 7-11 4-10 3-8l2-5 3 4 6 8q3 4 9 11t13 13 15 13 20 12 23 10 26 7 31 3q126 0 137-113 1-7 1-139v-86q0-38 2-45t11-10q21-3 49-3h16V0h-8l-23 1q-24 1-51 1t-38 1Q596 3 587 0h-8v46h16q61 0 61 16 1 2 1 138-1 135-2 143-6 28-20 42t-24 17-26 2q-45 0-79-34-27-27-34-55t-8-83V108q0-30 1-40t3-13 9-6q21-3 49-3h16V0h-8l-24 1q-23 1-50 1t-38 1Q319 3 310 0h-8v46h16q61 0 61 16 1 2 1 138-1 135-2 143-6 28-20 42t-24 17-26 2q-45 0-79-34-27-27-34-55t-8-83V108q0-30 1-40t3-13 9-6q21-3 49-3h16V0h-8l-23 1q-24 1-51 1t-38 1Q42 3 33 0h-8v46h16z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "math",
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "mtext",
    transform: "matrix(1 0 0 -1 417.6 0)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dpdx_units_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dpdx_units_svg__b",
    transform: "translate(681)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dpdx_units_svg__c",
    transform: "translate(1181)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dpdx_units_svg__d",
    transform: "translate(1681)"
  })))));
}
export default __webpack_public_path__ + "e2d97927f85cc8f92cbb742fcd898665.svg";
export { SvgDpdxUnits as ReactComponent };